import { useTranslation } from 'react-i18next';
import React from 'react';
import { ServiceBar } from '../organization/projects/view-project/clients-tab/headquarters-branches/project-branch-view/branch-services/shared-components/service-bar';
import { ServiceViewDetails } from '@lib/api-interface';

interface WasteDetailBarsProps {
  service: ServiceViewDetails;
}

export const WasteDetailBars = ({ service }: WasteDetailBarsProps) => {
  const { t } = useTranslation();

  if (service.serviceType !== 'PER_REQUEST' && service.serviceType !== 'SCHEDULED') {
    return null;
  }

  return (
    <>
      <ServiceBar
        headers={[
          { label: t('wastePhysicalPropertyType') },
          ...(service.wastePhysicalProperties?.propertyType === 'OTHER' ? [{ label: t('otherPhysicalProperty') }, { label: t('customWasteDescription') }] : []),
        ]}
        items={[
          {
            value: service.wastePhysicalProperties?.propertyType ? t(`wastePhysicalPropertyType.${service.wastePhysicalProperties.propertyType}`) : '',
          },
          ...(service.wastePhysicalProperties?.propertyType === 'OTHER'
            ? [{ value: service.wastePhysicalProperties?.otherPhysicalProperty }, { value: service.wastePhysicalProperties?.customWasteDescription }]
            : []),
        ]}
      />
      <ServiceBar
        headers={[
          { label: t('wastePackagingType') },
          { label: t('packageNumber') },
          ...(service.wastePackaging?.packagingType === 'OTHER' ? [{ label: t('otherWastePackaging') }] : []),
        ]}
        items={[
          {
            value: service.wastePackaging?.packagingType ? t(`wastePackagingType.${service.wastePackaging.packagingType}`) : '',
          },
          { value: service.wastePackaging?.packageNumber },
          ...(service.wastePackaging?.packagingType === 'OTHER' ? [{ value: service.wastePackaging?.otherWastePackaging }] : []),
        ]}
      />
      <ServiceBar
        headers={[
          { label: t('reportOnWasteProcessing') },
          { label: t('wasteFlowPurpose') },
          { label: t('wasteFlowQuantityMethod') },
          { label: t('wasteFlowTransportMethod') },
          { label: t('senderDateOfDelivery') },
          { label: t('wasteFlowLicensePlates') },
          { label: t('carrierReceivedBy') },
          { label: t('carrierDeliveryDate') },
          { label: t('carrierSubmittedBy') },
          { label: t('recipientReceivedBy') },
          { label: t('recipientDateOfWeighing') },
          { label: t('recipientQuantityTakenInKg') },
        ]}
        items={[
          { value: service.wasteFlow?.reportOnWasteProcessing, type: 'boolean' },
          { value: service.wasteFlow?.purpose ? t(`wasteFlowPurpose.${service.wasteFlow.purpose}`) : '' },
          { value: service.wasteFlow?.quantityMethod ? t(`wasteFlowQuantityMethod.${service.wasteFlow.quantityMethod}`) : '' },
          { value: service.wasteFlow?.transportMethod ? t(`wasteFlowTransportMethod.${service.wasteFlow.transportMethod}`) : '' },
          { value: service.wasteFlow?.senderDateOfDelivery },
          { value: service.wasteFlow?.wasteFlowLicensePlates },
          { value: service.wasteFlow?.carrierReceivedBy },
          { value: service.wasteFlow?.carrierDeliveryDate },
          { value: service.wasteFlow?.carrierSubmittedBy },
          { value: service.wasteFlow?.recipientReceivedBy },
          { value: service.wasteFlow?.recipientDateOfWeighing },
          { value: service.wasteFlow?.recipientQuantityTakenInKg },
        ]}
      />
    </>
  );
};
